import React from "react";

const SyncSpinnerIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.8}
      d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
    />
  </svg>
);

const formatElapsed = (seconds) => {
  if (seconds < 60) return `${seconds}s`;
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}m ${secs}s`;
};

const GeneratingVideoPreview = ({
  imageUrl,
  compact = false,
  className = "",
  elapsedSeconds,
}) => {
  const sizeClass = className || (
    compact
      ? "aspect-[9/16] w-12 flex-shrink-0"
      : "w-full aspect-[9/16] max-h-[420px]"
  );

  return (
    <div className={`relative overflow-hidden rounded-lg border border-theme-secondary bg-theme-secondary ${sizeClass}`}>
      {imageUrl ? (
        <img src={imageUrl} alt="" className="absolute inset-0 h-full w-full object-cover" />
      ) : (
        <div className="absolute inset-0 bg-theme-secondary" />
      )}
      <div className="absolute inset-0 bg-black bg-opacity-45 flex flex-col items-center justify-center gap-1.5 p-2 text-center">
        <SyncSpinnerIcon
          className={`text-theme-primary animate-spin ${compact ? "w-4 h-4" : "w-8 h-8"}`}
        />
        {!compact ? (
          <>
            <p className="text-sm font-medium text-white">Generating</p>
            {elapsedSeconds != null ? (
              <p className="text-xs text-white opacity-80">
                {formatElapsed(elapsedSeconds || 0)} elapsed
              </p>
            ) : null}
          </>
        ) : null}
      </div>
    </div>
  );
};

export default GeneratingVideoPreview;
